module.exports = __webpack_public_path__ + "img/friendStar.99aa8ae3.svg";